import cx from 'classnames';
import { t } from 'i18next';
import moment from 'moment/moment';
import { formatMsShort } from '../../../../../../../shared/frontend/libs/utils';
import { asset } from '../../../../../../../shared/frontend/services/assetResolverService';
import {
  getKeystoneLeaderboardPeriodDates,
  getRaidWeeklyRotationStatus
} from '../../../../../../../shared/common/utils';
import CountdownTimer from '../../../../../../../shared/frontend/components/presentational/countdownTimer';

export type TFatedCountdownProps = {
  className?: string;
  style?: any;
  intervalStartDate: moment.Moment;
  intervalEndDate: moment.Moment;
  intervalWeeks: number;
  intervalActiveAfterRotationDate: moment.Moment;
  isAlwaysActiveAfterRotation: boolean;
  raid: any;
};

export function FatedCountdown(props: TFatedCountdownProps) {
  const fatedRot = getRaidWeeklyRotationStatus({
    regionSlug: 'us',
    rotationStartDate: props.intervalStartDate,
    rotationEndDate: props.intervalEndDate,
    alwaysActiveEndDate: props.intervalActiveAfterRotationDate,
    isAlwaysActiveAfterRotation: props.isAlwaysActiveAfterRotation,
    rotationWeeks: props.intervalWeeks,
    rotationWeeksActive: 1,
    currentDate: moment.utc()
  });

  let interior: any = null;

  if (fatedRot.isActive) {
    interior = (
      <div className={cx('slds-text-align--center', props.className)}>
        <span className="slds-text-heading--small slds-text-title--caps text-white text-bold">
          <b>
            <i className="fa fa-circle-play" style={{ color: '#00dd00' }} /> {t('frontpage:fated-now-active')}
          </b>
        </span>
      </div>
    );
  } else {
    const [nextPeriodDate] = getKeystoneLeaderboardPeriodDates('us', fatedRot.nextActivePeriod);

    // not yet active, so show when it becomes active next
    interior = (
      <CountdownTimer
        className={cx('slds-text-align--center', props.className)}
        to={nextPeriodDate.format()}
        formatter={(ms: number) => (
          <span className="slds-text-heading--small slds-text-title--caps text-white">
            <b>
              <i className="fa fa-circle-stop" style={{ color: '#dd0000' }} />{' '}
              {t('frontpage:fated-in-time', { countdown: formatMsShort(ms) })}
            </b>
          </span>
        )}
      />
    );
  }

  return (
    <div
      style={{
        background: `linear-gradient(0deg, rgba(26,23,22,1) 0%, rgba(26,23,22,0) 5%), url(${asset(
          `/images/${props.raid}/${fatedRot.isActive ? 'frontpage_bar_sm.jpg' : 'frontpage_bar_sm_gray.jpg'}`
        )})`,
        backgroundPosition: 'left top',
        backgroundSize: 'cover',
        ...props.style
      }}
    >
      {interior}
    </div>
  );
}
